define.alias("shared/components/shared-ig-media-card", "auth/components/shared-ig-media-card");